export default {
  viewBox: "0 0 12 14",
  html: "<path fill-rule=\"evenodd\" d=\"M7.743.063a.5.5 0 0 1 .24.569L6.654 5.5H11.5a.5.5 0 0 1 .366.841l-7 7.5a.5.5 0 0 1-.848-.473L5.345 8.5H.5a.5.5 0 0 1-.366-.841l7-7.5a.5.5 0 0 1 .61-.096\" clip-rule=\"evenodd\"/>"
};